import { render, staticRenderFns } from "./GrupoEconomicoCadastroModal.vue?vue&type=template&id=329b3fa1&scoped=true"
import script from "./GrupoEconomicoCadastroModal.vue?vue&type=script&lang=js"
export * from "./GrupoEconomicoCadastroModal.vue?vue&type=script&lang=js"
import style0 from "./GrupoEconomicoCadastroModal.vue?vue&type=style&index=0&id=329b3fa1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329b3fa1",
  null
  
)

export default component.exports